import { Dispatch } from "redux";
import { IUser } from "../../models/user.interface";
import { UserActionTypes } from "./types";
import { userService } from "../../services/user.service";

export interface UserAction {
  type: UserActionTypes;
  payload: IUser | null;
}

export const userActions = {
  checkRelatedPolicies: (email: string) => {
    return async (dispatch: Dispatch) => {
      await userService.checkRelatedPolices(email).then(response => {
        dispatch<UserAction>({
          type: UserActionTypes.CHECK_RELATED_POLICIES,
          payload: response.data
        });
      });
    };
  },
  getMinimumStartDate: () => {
    return async (dispatch: Dispatch) => {
      await userService.getMinimumStartDate().then(response => {
        dispatch<UserAction>({
          type: UserActionTypes.GET_MINIMUM_START_DATE,
          payload: response.data
        });
      });
    };
  }
};
